import { render, staticRenderFns } from "./BaseBtnBack.vue?vue&type=template&id=c06d56f2&"
import script from "./BaseBtnBack.vue?vue&type=script&lang=js&"
export * from "./BaseBtnBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports